import React from 'react';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const PaginationPreviousIcon = Atom.createRender(
  ({attributes, classes, generateAttributes}) => {
    return (
      <svg
        {...generateAttributes(attributes, classes)}
        height={px(12)}
        width={px(12)}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 12 12"
        transform="translate(0, 1)"
      >
        <path
          fill="none"
          stroke="currentColor"
          fillRule="evenodd"
          d="M8 10L4 6l4-4"
        />
      </svg>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Icon',
  className: 'w-pagination-previous-icon',
  showEmpty: false,
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Basic'), iconName('Star')),
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginRight: px(4),
        },
      },
    },
  },
  constraints: {
    ancestors: [
      {
        is: 'PaginationPrevious',
        rule: 'ExactlyOne',
      },
    ],
  },
  render: PaginationPreviousIcon,
  fields: {},
});

export default config;
